import { DOMSerializer } from "@tiptap/pm/model";

export function copyInlineSelection(view, event, cut = false) {
  const { selection, doc, schema } = view.state;
  const { from, to, $from, $to, empty } = selection;
  if (empty || !event?.clipboardData) return false;
  if (!$from.sameParent($to) || !$from.parent.isTextblock) return false;

  const inline = $from.parent.content.cut($from.parentOffset, $to.parentOffset);
  const container = document.createElement("div");
  container.appendChild(DOMSerializer.fromSchema(schema).serializeFragment(inline));

  event.clipboardData.setData("text/html", container.innerHTML);
  event.clipboardData.setData("text/plain", doc.textBetween(from, to));
  event.preventDefault();
  if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView());
  return true;
}
